import angular from 'angular';

(function() {
    'use strict';

    angular.module('app').component('applicationDetails', {
        template: require('./application-details.html'),
        controller: Ctrl,
        controllerAs: 'vm'
    });

    Ctrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        '$rootScope',
        'UploadService',
        'QueryService',
        'SessionService',
        '$timeout',
        'logger',
        'SweetAlert'
    ];

    function Ctrl(
        $scope,
        $state,
        $stateParams,
        $location,
        $rootScope,
        UploadService,
        QueryService,
        SessionService,
        $timeout,
        logger,
        SweetAlert
    ) {
        var vm = this;
        const audio_keys = ['application_audio', 'audio_answer1', 'audio_answer2', 'audio_answer3'];
        vm.audio_keys = audio_keys;
        vm.video_tips = require('Images/video_tips.png');
        vm.soundwave = require('Images/soundwave.png');
        vm.application_done = require('Images/application_done.png');

        vm.schedules = [
            "5:00 AM - 11:00 AM",
            "1:00 PM - 5:00 PM",
            "6:00 PM - 11:00 PM",
        ];

        vm.schedules = [
            "Morning",
            "Afternoon",
            "Evening",
        ];

        vm.schedule_times = {
        }

        vm.schedules.forEach((s, sindex) => {
            vm.schedule_times[s] = [];
            
            for(let i = 0; i < 12; i++){
                const t = i*2 + sindex*24+20;
                const time_string = int_to_time(t) + '  - ' + int_to_time(t + 2);
                vm.schedule_times[s].push(time_string);
            }


        });

        vm._schedules = {}
        vm.parse_availability = () => {
            // var availability = '';
            // for(var k in vm._schedules){
            //     if(k == "others"){
            //         availability += 'Other - ' + vm._schedules[k] + '\n';
            //     }else{
            //         if(vm._schedules[k]){
            //             availability += k + '\n';
            //         }
            //     }

            // }
            // return availability
            return JSON.stringify(vm._schedules) 
        }

        vm.upload_resume = (file) =>{

            if(!file){
                alert("Invalid file: please upload your resume in pdf format")
            }

            UploadService.upload(
                file,
                'application/pdf',
                { path: 'application_audio', type: file.type },
                location => {
                    
                    var req = {
                        method: 'PUT',
                        route: { teacher: vm.user.id }, 
                        body: { written_input: location }
                    };

                    QueryService.query(req)
                        .then(function(response) {
                            vm.submit_interview_details()
                        });
    
                }
            );

        }


        function int_to_time(hour){
            return (
                ('' + parseInt(hour / 4)).padStart(2, '0') +
                ':' +
                ('' + ((hour % 4) * 15).toFixed(0)).padStart(2, '0')
            );
        };

        vm.count_hours = () => {
            
            let hours = 0;
            vm.schedules.forEach(s => {
                vm.schedule_times[s].forEach(st => {
                    if(vm._schedules[s] && s != 'Afternoon'){
                        if(vm._schedules[st]){
                            hours += 0.5;
                        }
                    }
                })
            });
            return hours * 5;
        }

        vm.submit_interview_details = () => {
            
            // count schedule hours per day
            let hours = 0;
            vm.schedules.forEach(s => {
                vm.schedule_times[s].forEach(st => {
                    if(vm._schedules[s] && s != 'Afternoon'){
                        if(vm._schedules[st]){
                            hours += 0.5;
                        }
                    }
                })
            });

            if(hours < 3){
                vm.needs15hours = 1
            }else{
                start();
            }

            function start(){

                var req = {
                    method: 'PUT',
                    route: { teacher: vm.user.id }, 
                    body: { availability: vm.parse_availability() }
                };

                QueryService.query(req)
                    .then(function(response) {
                        getData();
                    });
            }

        }

        vm.unfinalize = () => {
            
            var req = {
                method: 'PUT',
                route: { teacher: vm.user.id }, 
                body: { 
                    application_status: 'NOT-FINALIZED',
                    status: 'ACTIVE'
                }
            };

            QueryService.query(req)
                .then(function(response) {
                    getData();
                });

        }

        vm.user = SessionService.getUser();

        //get localstorage
        vm.agreed_to_terms = localStorage.getItem('agreed_to_terms');
        vm.is_recording_audio = 0
        vm.audio_page = 0;
        // vm.is_recording_video = 1;
        vm.video_page = -1;
        vm.logout = () => {
            SessionService.clearUser();
            location.reload();
        }

        if(!vm.user){
            $state.go('login2');
        }else{
            getData();
        }

        vm.getData = getData;

        function getData(){
            
            var req = {
                method: 'GET',
                route: { teacher: 'me' }, 
            };

            QueryService.query(req)
                .then(function(response) {
                    vm.page = 1;
                    var data = response.data.data;


                    if (!data.resume || !isJsonObject(data.resume)
                    ) {
                        vm.item_details.resume = {
                            work: [],
                            educ: []
                        };
                    } else {
                        vm.item_details.resume = JSON.parse(data.resume);
                    }

                    vm.kakao_id = data.kakao_id;
                    if(data.application_status == 'PASSED'){
                        vm.page = 'AUDIO-SCREENING'
                    }else if(data.application_status == 'FINALIZED'){
                        vm.page = 'FINALIZED'
                    }else{
                        vm.data = data;
                        if(vm.data.quiz){
                            vm.data.quiz = JSON.parse(vm.data.quiz)
                        }else{
                            vm.data.quiz = [];
                        }

                        vm.correct_answers = 0;
                        vm.data.quiz.forEach(q => {
                            if(q.correct){
                                vm.correct_answers++
                            }
                        });

                        audio_keys.forEach(k => {
                            vm[k] = vm.data[k];
                        });
                        
                        if(!vm.data.video_answers){
                            vm.data.video_answers = []; 
                        }else{
                            vm.data.video_answers = JSON.parse(vm.data.video_answers);
                        }

                        vm.agreed_to_terms = vm.data.application_status;

                        get_quiz();

                    }

                    // var schedules = vm.data.availability.trim().split('\n')
                    // schedules.forEach((s) => {
                    //     if(s.includes('Other - ')){
                    //         vm._schedules['others'] = s.split('Other - ')[1]
                    //     }else{
                    //         vm._schedules[s] = true
                    //     }
                    // });
                    // console.log(vm.data.availability);
                    if(isJsonObject(vm.data.availability)){
                        vm.data.availability = JSON.parse(vm.data.availability)
                        vm._schedules = data.availability
                    }
                    // console.log(vm.data.availability);

                });
        }

        vm.finalize = () => {
            
            var req = {
                method: 'PUT',
                route: { teacher: vm.user.id }, 
                body: { application_status: 'FINALIZED' }
            };

            QueryService.query(req)
                .then(function(response) {
                    vm.can_summary = false;
                    vm.submit_interview_details();
                    getData();
                });
        }

        vm.can_finalize = () => {
            if(!vm.data){
                return false;
            }

            if(!vm.item_details.resume){
                return false
            }else{
                const resume = vm.item_details.resume;
                if(!(resume instanceof Object)){
                    return false
                }


                if(resume.work.length == 0 || resume.educ.length == 0){
                    return false;
                }

                let has_incomplete = false;
                resume.work.forEach(w => {
                    if(w.incomplete){ 
                        has_incomplete = true 
                    }
                })

                resume.educ.forEach(w => {
                    if(w.incomplete){ 
                        has_incomplete = true 
                    }
                });


                if(has_incomplete){
                    return false
                }

            }

            if(vm.count_hours() < 15){
                return false;
            }

            return vm.data.kakao_id;
        }

        vm.agree_to_terms = () => {
            
            vm.loading = true;
            var request = {
                method: 'PUT',
                body: { application_status: 'NOT-FINALIZED' },
                route: { teacher: vm.user.id },
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        getData();
                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );

        }

        vm.delete_me = () => {
            
            vm.loading = true;
            var request = {
                method: 'DELETE',
                route: { teacher: 'me' }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.logout();
                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );

        }
        //------------------------------------------quiz stuff------------------------------------------
        function get_quiz(){
            var request = {
                method: 'GET',
                params: false,
                hasFile: false,
                route: { quiz: 'teacher2' }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const d = response.data.data.items;
                        d.forEach(_d => {
                            _d.choices = _d.choices.replace(/\t/g, '');
                            _d.choices = JSON.parse(_d.choices)[0];
                        });
                        
                        vm.quiz_all = JSON.parse(JSON.stringify(d));
                        vm.quiz = d;
                        // vm.quiz.splice(0, 10)
                        console.log('vm.quiz', vm.quiz)
                        if(vm.data.quiz.length > 0){

                            if(vm.correct_answers >= vm.quiz.length * 0.8){
                            // if(vm.correct_answers >= 8){
                                vm.page++;

                                if(audio_keys.filter(k => vm[k]).length == audio_keys.length){
                                    vm.page++;

                                    if(vm.data.video_answers.length == 6){
                                        console.log(vm.data.video_answers)
                                        vm.can_summary = true;
                                        vm.page++;
                                        vm.audio_page = 0;
                                        vm.is_recording_audio = 1;
                                        vm.page = 2;
                                    }
                                }
                                

                            }else{
                                vm.quiz_failed = true;
                                vm.quiz_started = false;
                            }

                        }

                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });

        }

        vm.get_quiz_by_id = id => {
            if(vm.quiz_all)
                return vm.quiz_all.find(q => q.id === id)
        }
        vm.start_quiz = () => {
            vm.quiz_page = 0;
            vm.quiz_started = true;
            vm.start = new Date();
            update_timer();
        }

        const __mins = 15;
        const __seconds = 60;
        
        vm.get_timer = ()=>{

            function pad(num) {
                return ("0"+num).slice(-2);
            }
            function hhmmss(secs) {
              var minutes = Math.floor(secs / 60);
              secs = secs%60;
              var hours = Math.floor(minutes/60)
              minutes = minutes%60;
              return `${pad(minutes)}:${pad(secs)}`;
            }

            const start = (vm.start.getTime() || 0);
            const end = (vm.end.getTime() || 0);

            return hhmmss(parseInt((__mins*__seconds*1000 + (start - end))/1000));
        };
        function update_timer(apply){
            vm.end = new Date();

            if(vm.quiz_submitted){
                return false;
            }

            if(__mins*__seconds*1000 + (vm.start.getTime() - vm.end.getTime()) < 0 ){
                vm.submit_quiz();
                vm.ran_out_of_time = true;
            }else{
                $timeout(()=>{update_timer(1)}, 1000);
            }
            if(apply){
                vm.end = new Date();
                $scope.$apply();
            }
        }
        
        vm.submit_quiz = ()=>{
            const answers = vm.quiz.map(q => {return { id: q.id, chosen: q.answer }  });

            vm.loading = true;
            var request = {
                method: 'POST',
                body: {
                    answers
                },
                route: { quiz: 'teacher' }, 
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data.answers;
                        vm.answers = data;
                        vm.page++;
                        vm.quiz_submitted = 1;

                        const correct_answers = data.filter(d => d.correct).length;
                        vm.correct_answers = correct_answers;
                        getData();
                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );

        };
        //-------------------------------------------------------end quiz-------------------------------------------------------
        //-----------------------------------------------------audio stuff------------------------------------------------------
        
        vm.chunks = [];
        
        navigator.getUserMedia ({ audio: true }, ()=>{

            navigator.mediaDevices.enumerateDevices()
            .then(function(devices) {
                const d = devices.filter(s => s.kind == 'audioinput');

                d.forEach(_d => vm.devices.push(_d));
                vm.selected_device = '0';
                $scope.$apply();
            });
        }, ()=>{

        });

        init_record('audio_answer1');
        init_record('audio_answer2');
        init_record('audio_answer3');
        init_record('application_audio');
        function init_record(i){
            vm.devices = [];
            vm.selected_device = 0;
            vm[i+'_mode'] = 'stopped';
        }

        vm.record_button_clicked = record_button_clicked;
        vm.start_record = start_record;
        vm.stop_record = stop_record;
        function start_record(i){

            const deviceId = vm.devices[vm.selected_device].deviceId;

            window.AudioContext = window.AudioContext || window.webkitAudioContext;

            vm.context = new AudioContext();

            var userMedia_params = { 
                audio: { deviceId }
            };

            navigator.mediaDevices.getUserMedia(userMedia_params).then((stream) => {
                
                vm[i + '_recorder'] = new MediaRecorder(stream);
                vm[i + '_recorder'].start();


                vm[i + '_recorder'].ondataavailable = function(e) {
                    vm.chunks.push(e.data);
                }
                
                vm[i + '_recorder'].onstop = () => {

                    var audio = document.getElementById('audioplayer_'+i);
                    audio.setAttribute('controls', '');
                    audio.controls = true;
                    var blob = new Blob(vm.chunks, { 'type' : 'audio/ogg; codecs=opus' });
                    vm.chunks = [];

                    var audioURL = URL.createObjectURL(blob);
                    audio.src = audioURL;
                    // audio.play();
                    setTimeout(()=>{
                        audio.pause();
                    }, 200);

                    const file = blobToFile(blob,'test.ogg');

                    UploadService.upload(
                        file,
                        'audio/ogg; codecs=opus',
                        { path: 'application_audio', type: file.type },
                        location => {
                            vm[i] = location;
                            vm.save_audio(i);
                        }
                    );

                }
                
            });

            vm[i + '_recording_start'] = new Date();
            set_timer(i);


            function blobToFile(theBlob, fileName){
                return new File([theBlob], fileName, {lastModified: new Date(), type: theBlob.type})
            }
        }

        function stop_record(i){
            vm[i + '_recorder'].stop();
            vm[i + '_mode'] = 'stopped';
            vm[i + '_recorded'] = 1;
        }

        function record_button_clicked(i, video){

            if(vm[i]){
                remove_audio(i);

            }else{
                start();
            }

            function start(){

                if(vm[i+'_mode'] === 'stopped'){
                    vm[i+'_mode'] = 'recording';
                    start_record(i, video);
                } else

                if(vm[i+'_mode'] === 'recording'){
                    vm[i+'_mode'] = 'stopped';
                    stop_record(i, video);
                }

                console.log(i);
            }

        }
        vm.remove_audio=remove_audio;
        function remove_audio(i){
            function start(){

                vm[i + '_recording_start'] = new Date();
                set_timer();
                
                var audio = document.getElementById('audioplayer_' + i);
                audio.setAttribute('controls', '');
                audio.controls = false;
                
                vm[i + '_duration'] = 0;
                vm[i] = null;

            }

            SweetAlert.swal(
                {
                    title: 'Warning: Clicking Record Again will overwrite your previous recording. ',
                    text: ``,
                    type: 'warning',
                    confirmButtonText: 'Proceed',
                    cancelButtonText: 'Cancel',
                    showCancelButton: true,
                    closeOnConfirm: true,
                    html: true,
                    closeOnCancel: true
                },
                function(proceed) {
                    if (proceed) {
                        start();
                    }
                }
            );
        }
        function set_timer(i){
            const seconds = parseInt((new Date() - vm[i + '_recording_start'])/1000);
        
            vm[i + '_duration'] = (parseInt(seconds/60)+'').padStart(2, '0') + ':' + (seconds % 60 + '').padStart(2, '0');
            setTimeout(()=>{
                $scope.$apply();
                if(vm[i + '_mode'] === 'recording'){
                    set_timer(i);
                }
            }, 1000);

        }

        vm.save_audio = (key) => {

            vm.loading = true;
            var request = {
                method: 'PUT',
                body: { [key]: vm[key]},
                route: { teacher: vm.user.id },
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        logger.success('Details Saved!');
                        
                        if(!vm.audio_keys[vm.audio_page]){
                            vm.is_recording_audio = false;
                            getData();
                        }
                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );
        }

        vm.check_audio_done = () => {
            vm.resetting_audio = true;
            setTimeout(()=>{
                vm.resetting_audio = false;
                $scope.$apply();
            }, 100);
            const key = vm.audio_keys[vm.audio_page];
            if(!key){
                getData()
            }
        }
        vm.check_video_done = () => {
            var video = document.getElementById('video_player');
            video.pause();
        }

        //-----------------------------------------------------audio stuff------------------------------------------------------
        //-----------------------------------------------------video stuff------------------------------------------------------
        vm.video_questions = [
            'Can you give us an overview of your professional background? Will this be your first time teaching Koreans and using KakaoTalk?',
            'If hired, will this be your first time doing an audio class? What do you think are the disadvantages of an audio class and how do you plan to address them? ',
            'Can you tell us a bit more about your work from home set-up? What are the specs of your laptop or computer? Do you have noisy neighbors? How do you manage your day-to-day work?',
            'Can you teach for four to five hours per day? Are you available from 7 am to 11 am and/or 7 pm to 11 pm? ',
            'A booking schedule does not guarantee that you will be able to fill all your slots immediately. Are you amenable to waiting a few days to two weeks before you can fill in all your slots? ',
            'We offer free demo classes to our students. Are you okay with teaching a demo class under this condition, or will this be an issue for you?',
        ];
        vm.video_errored = false;
        vm.init_video = init_video;
        // vm.is_recording_video = 1;
        vm.play_video_recorded = () => {
            vm.video_player_playing = !vm.video_player_playing;
            var video = document.getElementById('video_player');

            if(vm.video_player_playing){
                video.play();
            }else{
                video.pause();
            }
        }
        init_video();
        function init_video(){
            navigator.mediaDevices.getUserMedia({
                audio: true,
                video: true
            }).then((stream) => {
                vm.video_errored = false;
                $scope.$apply()
                const video_stream = new MediaRecorder(stream);
                vm.video_stream = video_stream;

                var preview = document.getElementById('video_preview')
                preview.srcObject = stream

                video_stream.ondataavailable = function(e) {
                    vm.video_chunks.push(e.data);
                }
                
                video_stream.onstop = () => {
                    
                    var video = document.getElementById('video_player');
                    video.setAttribute('controls', '');
                    video.controls = true;
                    var blob = new Blob(vm.video_chunks, { 'type' : 'video/mp4' });

                    var videoURL = URL.createObjectURL(blob);
                    video.src = videoURL;
                    setTimeout(()=>{
                        video.pause();
                    }, 200);

                    vm.has_video = true;
                    $scope.$apply();
                    const file = blobToFile(blob,'test.mp4');

                    UploadService.upload(
                        file,
                        'video/mp4',
                        { path: 'application_video', type: file.type },
                        location => {
                            vm.data.video_answers[vm.video_page] = location;
                            vm.save_videos();
                        }
                    );

                    function blobToFile(theBlob, fileName){
                        return new File([theBlob], fileName, {lastModified: new Date(), type: theBlob.type})
                    }
                    vm.video_errored = false;

                }
            }).catch((err) =>{ 
                if(err){

                    console.log(err)
                    vm.video_errored = true;
                    setTimeout(() => {
                        init_video();
                    }, 1234);
                }
            });
            
        }

        vm.record_video_start = (countdown) => {
            vm.video_starting = true;
            function start(){
                vm.recording_video = true;
                vm.video_chunks = [];
                vm.video_stream.start();
                vm.has_video = false;
                vm.start = new Date();
                update_video_timer(0);
                vm.video_starting = false;
            }

            setTimeout(()=>{
                if(countdown){
                        vm.video321 = countdown;
                        vm.record_video_start(vm.video321 - 1);
                }else{
                    vm.video321 = countdown;
                    start();
                }
                $scope.$apply();
            }, 1000);
        }

        vm.record_video_stop = () => {
            vm.recording_video = false;
            vm.video_stream.stop();
        }


        function update_video_timer(apply){
            vm.end = new Date();
            if(vm.recording_video){
                $timeout(()=>{update_timer(1)}, 1000);
            }
            if(apply){
                vm.end = new Date();
                $scope.$apply();
            }
        }
        vm.get_video_timer = ()=>{

            function pad(num) {
                return ("0"+num).slice(-2);
            }
            function hhmmss(secs) {
              var minutes = Math.floor(secs / 60);
              secs = secs%60;
              var hours = Math.floor(minutes/60)
              minutes = minutes%60;
              return `${pad(minutes)}:${pad(secs)}`;
            }

            const start = (vm.start.getTime() || 0);
            const end = (vm.end.getTime() || 0);

            return hhmmss(parseInt((end - start)/1000));
        };

        vm.save_videos = () =>{
            
            vm.loading = true;
            var request = {
                method: 'PUT',
                body: { video_answers: JSON.stringify(vm.data.video_answers) },
                route: { teacher: vm.user.id },
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        logger.success('Details Saved!');
                        vm.is_recording_audio = false;
                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );
        };


        vm.submit_kakao_id = () => {
            
            var req = {
                method: 'PUT',
                route: { teacher: vm.user.id }, 
                body: { kakao_id: vm.kakao_id }
            };

            QueryService.query(req)
                .then(function(response) {
                    vm.getData();
                });
        }
        
        //-----------------------------------------------------video stuff------------------------------------------------------

        vm.item_details = {};
        vm.editing = 1;
        vm.editing_work_i = -1;
        vm.editing_educ_i = -1;
        vm.editing_cert_i = -1;


        vm.work_experience = new_work_experience();
        vm.education = new_education();
        vm.resume_months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        vm.year_options = [];
        vm.max_year = new Date().getFullYear();

        for (var i = 0; i < vm.max_year - 1949; i++) {
            const y = vm.max_year - i;
            vm.year_options.push(y);
        }
        vm.find_industry = id => {
            return vm.job_industries.find(k => k.id == id);
        };

        vm.creating_new_industry = false;
        vm.create_new_industry = work => {
            if (work.job_industry != 'create_new_industry') {
                return false;
            }
            vm.creating_new_industry = true;
            vm.creating_new_industry_work = work;
        };

        vm.getJobIndustries = getJobIndustries;
        getJobIndustries();
        function getJobIndustries(cb) {
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                params: false,
                hasFile: false,
                route: { settings: 'industries' },
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.job_industries = [];
                        vm.job_industry_parents = [];
                        const _job_industries = JSON.parse(
                            response.data.data.setting_data
                        );
                        _job_industries.forEach(j => {
                            vm.job_industry_parents.push(j);
                            vm.job_industries.push({
                                name: j.name,
                                unselectable: 1
                            });

                            j.children.forEach(k => {
                                const i = {
                                    ...k,
                                    original_name: k.name,
                                    name: `----${k.name}`,
                                    display: j.name + ' - ' + k.name,
                                    parent_name: j.name
                                };
                                vm.job_industries.push(i);
                            });
                        });
                        if (cb) {
                            cb();
                        }
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        vm.cancel_work = () => {
            const work = vm.item_details.resume.work[vm.editing_work_i];
            if (JSON.stringify(work) == JSON.stringify(new_work_experience())) {
                vm.remove_work(vm.editing_work_i, work);
            }
            if (vm.work_experience_backup) {
                vm.item_details.resume.work[vm.editing_work_i] =
                    vm.work_experience_backup;
                vm.work_experience_backup = false;
            }
            if (
                !work.description ||
                !work.end ||
                !work.job_industry ||
                work.job_industry == 'no_industry' ||
                !work.job_title ||
                !work.just_saved ||
                !work.place ||
                !work.start ||
                !work.start_month ||
                work.description.length < 100
            ) {
                work.incomplete = true;
                console.log('work');
                console.log(work);
            } else {
                delete work.incomplete;
            }
            vm.editing_work_i = -1;
        };

        vm.cancel_educ = () => {
            const educ = vm.item_details.resume.educ[vm.editing_educ_i];
            if (JSON.stringify(educ) == JSON.stringify(new_education())) {
                vm.remove_educ(vm.editing_educ_i, educ);
            }
            if (vm.educ_backup) {
                vm.item_details.resume.educ[vm.editing_educ_i] = vm.educ_backup;
                vm.educ_backup = false;
            }
            if (
                !educ.degree_program ||
                !educ.description ||
                !educ.end ||
                !educ.just_saved ||
                !educ.place ||
                !educ.start ||
                !educ.start_month
            ) {
                educ.incomplete = true;
            } else {
                delete educ.incomplete;
            }
            vm.editing_educ_i = -1;
        };
        vm.save_educ = educ => {
            educ.just_saved = true;
            vm.editing_educ_i = -1;

            if (
                !educ.degree_program ||
                !educ.description ||
                !educ.end ||
                !educ.just_saved ||
                !educ.place ||
                !educ.start ||
                !educ.start_month ||
                educ.description.length < 100
            ) {
                educ.incomplete = true;
            } else {
                delete educ.incomplete;
            }

            setTimeout(() => {
                educ.just_saved = false;
                $scope.$apply();
            }, 1200);

            save_resume();

        };
        vm.save_work = work => {
            work.just_saved = true;
            vm.editing_work_i = -1;
            console.log(work);

            if (
                !work.description ||
                !work.end ||
                !work.job_industry ||
                work.job_industry == 'no_industry' ||
                !work.job_title ||
                !work.just_saved ||
                !work.place ||
                !work.start ||
                !work.start_month ||
                work.description.length < 100
            ) {
                work.incomplete = true;
                console.log('work');
                console.log(work);
            } else {
                delete work.incomplete;
            }

            setTimeout(() => {
                work.just_saved = false;
                $scope.$apply();
            }, 1200);


            save_resume()
        };

        function save_resume(){
            
            var req = {
                method: 'PUT',
                route: { teacher: vm.user.id }, 
                body: { resume: JSON.stringify(vm.item_details.resume) }
            };

            QueryService.query(req)
                .then(function(response) {
                    getData();
                });


        }

        function new_work_experience() {
            return {
                start: new Date().getFullYear(),
                end: new Date().getFullYear(),
                start_month: 'January',
                end_month: 'January',
                job_title: '',
                job_industry: 'no_industry',
                place: '',
                description: '',
                incomplete: true
            };
        }
        function new_education() {
            return {
                start: new Date().getFullYear(),
                end: new Date().getFullYear(),
                start_month: 'January',
                end_month: 'January',
                degree_program: '',
                place: '',
                description: '',
                incomplete: true
            };
        }

        vm.add_certificate = () => {
            vm.item_details.certificates[false] = { name: 'IELTS' };
            if (!vm.item_details.certificate_keys.includes(false))
                vm.item_details.certificate_keys.push(false);
            vm.editing_cert_i = false;
        };

        vm.add_work_experience = () => {
            vm.work_experience = new_work_experience();
            vm.item_details.resume.work.push(vm.work_experience);
            vm.editing_work_i = vm.item_details.resume.work.length - 1;
        };
        vm.add_education = () => {
            vm.education = new_education();
            vm.item_details.resume.educ.push(vm.education);
            vm.editing_educ_i = vm.item_details.resume.educ.length - 1;
        };

        vm.edit_cert = key => {
            vm.editing_cert_i = key;
            vm.cert_backup = JSON.parse(
                JSON.stringify(vm.item_details.certificates[key])
            );
        };

        vm.edit_work = (i, work) => {
            vm.editing_work_i = i;
            vm.work_experience_backup = JSON.parse(JSON.stringify(work));
        };
        vm.edit_educ = (i, educ) => {
            vm.editing_educ_i = i;
            vm.educ_backup = JSON.parse(JSON.stringify(educ));
        };

        vm.remove_cert = key => {
            delete vm.item_details.certificates[key];
        };
        vm.remove_work = (i, work) => {
            vm.item_details.resume.work.splice(i, 1);
            save_resume();
        };
        vm.remove_educ = (i, educ) => {
            vm.item_details.resume.educ.splice(i, 1);
            save_resume();
        };

        vm.otherize_cert = cert => {
            if (!cert.other) {
                cert.name = '';
            }
            cert.other = true;
        };
        function isJsonObject(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return JSON.parse(str) instanceof Object;
        }

        //--------------------------------------------------------resume--------------------------------------------------------
        vm.get_availability_count = ()=>{

            var request = {
                method: 'GET',
                route: { availability: ''},
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        vm.availability = data;
                        if(data.morning - data.evening <= -10){
                            vm.availability.disabled_Morning = true;
                        }

                        if(data.evening - data.morning <= -10){
                            vm.availability.disabled_Evening = true;
                        }

                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );
        }
        vm.get_availability_count();
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/application-details/application-details.component.js